import { render, staticRenderFns } from "./extra-lightbox.vue?vue&type=template&id=fe682a38&lang=pug&"
import script from "./extra-lightbox.vue?vue&type=script&lang=js&"
export * from "./extra-lightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports